import logo from './logo.svg';
import './App.css';
import MainPage from './components/pages/MainPage';
import { Link, Route, Router, Routes } from 'react-router-dom';
import PrivacyPolicy from './components/pages/PrivacyPolicy';
import Referral from './components/pages/Referral';
import RefundPolicy from './components/pages/RefundPolicy';
import SponsershipDisclaimer from './components/pages/SponsershipDisclaimer';
import TermsAndCondtion from './components/pages/TermsAndCondtion';
import ProcessOverview from './components/pages/ProcessOverview';
import Education from './components/pages/Education';
import Sma from './components/pages/Sma';
import Ema from './components/pages/Ema';
import Vwap from './components/pages/Vwap';
import StochasticOscillator from './components/pages/StochasticOscillator';
import Rsi from './components/pages/Rsi';
import Obv from './components/pages/Obv';
import FibonacciRetracement from './components/pages/FibonacciRetracement';
import Adx from './components/pages/Adx';
import Macd from './components/pages/Macd';
import Bollingerbrands from './components/pages/Bollingerbrands';
import Doc from './components/pages/Doc';
import ATR from './components/pages/ATR';
import PivotPoint from './components/pages/PivotPoint';


function App() {
  return (



    <Routes>



      <Route path="/" element={<MainPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/referral" element={<Referral />} />
      <Route path="/refund-policy" element={<RefundPolicy />} />
      <Route path="/sponsership-disclaimer" element={<SponsershipDisclaimer />} />
      <Route path="/terms-condition" element={<TermsAndCondtion />} />
      <Route path="/process-overview" element={<ProcessOverview />} />
      <Route path="/education" element={<Education />} />

      <Route path="/simple-moving-average-indicator-algocontroller" element={<Sma />} />
      <Route path="/exponential-moving-average-indicator-algocontroller" element={<Ema />} />
      <Route path="/volume-weighted-average-price-indicator-algocontroller" element={<Vwap />} />
      <Route path="/stochastic-oscillator-indicator-algocontroller" element={<StochasticOscillator />} />
      <Route path="/relative-strength-index-indicator-algocontroller" element={<Rsi />} />
      <Route path="/on-balance-volume-indicator-algocontroller" element={<Obv />} />
      <Route path="/fibonacci-retracement-indicator-algocontroller" element={<FibonacciRetracement />} />
      <Route path="/average-directional-index-indicator-algocontroller" element={<Adx />} />
      <Route path="/moving-average-convergence-divergence-indicator-algocontroller" element={<Macd />} />
      <Route path="/bollinger-bands-indicator-algocontroller" element={<Bollingerbrands />} />
      <Route path="/average-true-range-indicator-algocontroller" element={<ATR />} />
      <Route path="/pivot-point-indicator-algocontroller" element={<PivotPoint />} />



      <Route path="/doc" element={<Doc />} />









    </Routes>

  );
}

export default App;
